<template>
  <v-container class="container-outer" fluid>
    <v-card tile flat class="action-outer d-flex flex-column justify-start align-center theme-border theme-background">
      <v-card tile flat class="d-flex justify-center action-title transparent theme-title">
        {{ blockByModification ? 'Esemény szerkesztése' : 'Új esemény' }}
      </v-card>
      <v-card tile flat class="d-flex justify-center align-center action-progress transparent"
              :class="direction ? 'flex-row-reverse' : 'flex-row'">
        <Goal little style="order: 1;" :class="direction ? 'mr-2' : ''"/>
        <v-card tile flat class="action-name" :class="direction ? 'reverseArrow mr-4' : ''"
                :style="{'order': direction ? 2 : 3, 'color': $vuetify.theme.dark ? '#000000' : '#ffffff', 'background-color': $vuetify.theme.dark ? '#ffffff' : '#9298af'}">
          <div class="arrow-inner">
            {{ actualAction }}
            <span class="theme-text" v-if="actualActionTypeName">({{ actualActionTypeName }})</span>
          </div>
        </v-card>
        <v-card tile flat class="player-text" :class="direction ? 'reverseArrow ml-2' : ''"
                :style="{'order': direction ? 2 : 3, 'color': $vuetify.theme.dark ? '#000000' : '#ffffff', 'background-color': $vuetify.theme.dark ? '#ffffff' : '#9298af'}">
          <div class="arrow-inner">{{ player.jersey }} {{ player.name }}</div>
        </v-card>
        <v-btn v-if="!blockByModification" depressed outlined tile class="action-time" style="order: 4;">
          {{ createAction.gameTime }}
        </v-btn>
        <template v-if="blockByModification">
          <v-btn icon @click="decreaseTime" :style="{'order' : direction ? 6 : 4}">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
          <v-text-field
              v-model="createAction.gameTime"
              variant="outlined"
              class="ma-0 pa-0"
              style="order: 5;"
              :rules="[timeFormatRule]"
              maxlength="5"
              counter
              hide-details="auto"
              @blur="formatGameTime"
          ></v-text-field>
          <v-btn icon @click="increaseTime" :style="{'order' : direction ? 4 : 6}">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-card tile flat class="team-name transparent theme-title" style="order: 7;">{{ teamName }}</v-card>
      </v-card>
      <v-card tile flat class="d-flex justify-center mt-4 transparent">
        <v-btn depressed tile @click="cancelAction" class="theme-back theme-border bottom-actions">Mégsem</v-btn>
        <v-btn :disabled="saveDisabled" depressed tile @click="manualSaveAction"
               class="theme-back theme-border bottom-actions">Mentés
        </v-btn>
        <v-progress-circular v-if="saveInProgress && spinnerTimeout && saveTime > 0"
                             :rotate="270"
                             :size="32"
                             :value="spinner"
                             color="#23C373"
                             class="ml-2 mt-1"
        >{{ Math.round(saveTime - Math.floor(saveTime * (spinner / 100))) }}
        </v-progress-circular>
      </v-card>
    </v-card>
    <v-row justify="center" class="dialog-container">
      <v-dialog v-model="scapegoatModal.show" persistent max-width="500">
        <v-card tile flat>
          <v-card-title class="headline">Hivatalos személy kiállítás</v-card-title>
          <v-card-text>
            <p>Ki ülje le a büntetését?</p>
            <p>Az így kapott kiállítás <b>nem</b> számít bele a piros laphoz szükséges 3 kiállításba!</p>
            <v-select
                v-model="scapegoatModal.selected"
                class="width-100"
                :items="scapegoatModal.players"
                item-disabled=""
                item-value="id"
                :item-text="(player) => player.jersey + ' ' + player.name"
                label="Játékos"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn depressed @click="scapegoatNotSelected">Mégsem</v-btn>
            <v-btn depressed color="green" @click="scapegoatSelected">Kiállítás</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import Goal from "../components/Goal";
import eventBus from '@/eventBus';
import CONSTANTS from '@/constants';
import {mapState} from "vuex";

import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
  name: "ActionBar",
  components: {
    Goal,
  },
  props: {
    direction: Boolean,
    gamedata: Object,
    isMirrored: Boolean
  },
  data: () => ({
    createAction: {
      selectedPlayer: null,
      selectedScapegoat: null,
      selectedTeam: null,
      selectedAction: null,
      selectedActionType: null,
      selectedArea: null,
      selectedGateArea: null,
      gameTime: null,
      otherTeamGoalKeeper: null,
      selectedTeamId: null,        //teamA || teamB
      teamScore: null
    },
    teamName: null,
    player: {
      name: "",
      jersey: "",
    },
    selectedTeam: null,
    actualAction: null,
    actualActionTypeName: null,
    saveInProgress: false,
    spinner: 0,
    saveTime: 0,
    saveTimeout: null,
    spinnerTimeout: null,
    blockByModification: false,
    basic: false,
    modifiedRecordId: null,
    scapegoatModal: {
      show: false,
      players: [],
      selected: undefined,
    },
    currentModifiedRecord: {},
    recordCreateStartTime: 0,
    recordCreateStartTotalGameTime: 0,
    buttonDisabledForSaving: false,
    preEditDirection: null
  }),
  methods: {
    resetCourtDirection: function () {
      // Ha van elmentett előző állapot, azt állítjuk vissza
      if (this.preEditDirection) {
        eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIRECTION, this.preEditDirection);
        this.preEditDirection = null; // Töröljük a memóriát
      } else {
        // Biztonsági tartalék: Ha valamiért nincs mentett, akkor az aktuális támadót nézzük
        let isTeamAAttacking = this.$store.state.game.teamA.isAttacking;
        let currentDirection = isTeamAAttacking ? 'left' : 'right';
        eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIRECTION, currentDirection);
      }
    },
    timeFormatRule(value) {
      const regex = /^([0-5][0-9]):([0-5][0-9])$/;
      return regex.test(value) || 'Helyes formátum: MM:SS';
    },
    formatGameTime() {
      const parts = this.createAction.gameTime.split(':');
      if (parts.length === 2) {
        let [min, sec] = parts;
        min = min.padStart(2, '0');
        sec = sec.padStart(2, '0');
        this.createAction.gameTime = `${min}:${sec}`;
      }
    },
    increaseTime() {
      if (!this.createAction.gameTime) {
        this.createAction.gameTime = '00:15';
        return;
      }

      let [min, sec] = this.createAction.gameTime.split(':').map(Number);
      let total = min * 60 + sec + 15;

      // opcionális maximum korlát (pl. 59:59 = 3599 mp)
      if (total > 3599) total = 3599;

      this.createAction.gameTime = this.formatSeconds(total);
    },

    decreaseTime() {
      if (!this.createAction.gameTime) return;

      let [min, sec] = this.createAction.gameTime.split(':').map(Number);
      let total = Math.max(0, min * 60 + sec - 15);

      this.createAction.gameTime = this.formatSeconds(total);
    },

    formatSeconds(seconds) {
      const m = String(Math.floor(seconds / 60)).padStart(2, '0');
      const s = String(seconds % 60).padStart(2, '0');
      return `${m}:${s}`;
    },
    scapegoatSelected() {
      this.scapegoatModal.show = false;
      this.createAction.selectedScapegoat = this.scapegoatModal.selected;
      this.scapegoatModal.selected = undefined;
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false);
    },
    scapegoatNotSelected() {
      this.scapegoatModal.show = false;
      this.scapegoatModal.selected = undefined;
      this.createAction.selectedScapegoat = null;
      this.cancelAction();
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false);
    },
    cancelAction: function () {
      this.saveInProgress = false;
      this.blockByModification = false;
      this.$store.commit('game/SET_EDITING_RECORD', null);

      this.resetCourtDirection();
      eventBus.$emit(CONSTANTS.EVENTS.RECORD.CREATED, {
        action: 'cancelled',
        params: {
          selectedAction: null,
          selectedTeamId: null,
          selectedActionType: null,
          selectedPlayer: null,
          selectedArea: null,
          selectedGateArea: 0
        }
      });
    },
    spinnerRoll: function () {
      let self = this;

      self.spinnerTimeout = window.setTimeout(() => {
        if (self.saveInProgress && window.autosave && self.spinner < 100) {
          self.spinner += 5 / window.saveTime;

          if (self.spinner > 100) {
            self.spinner = 100;
            self.spinnerTimeout = null;
          } else {
            self.spinnerRoll();
          }
        }
      }, 45); //50
    },
    saveAction: function (event, action, params) {
      let self = this;
      let optionalParams = Object.assign({}, params);

      let actions = ['gol', 'gol2p','vedett', 'rontott', 'kapufa', 'gol7m', 'vedett7m', 'rontott7m', 'kapufa7m', 'technikai', 'eladott', 'gol6m', 'vedett6m', 'kapufa6m', 'rontott6m', 'blokkolt'];

      const resolveGoalkeeper = (gkData) => {
        if (!gkData || gkData.id === undefined || gkData.id === null) return null;

        if (typeof gkData.id === 'object') {
          if (gkData.id.value !== undefined && gkData.id.value !== null) {
            return {
              ...gkData.id,
              id: gkData.id.value
            };
          }
          return null;
        }

        return { id: gkData.id };
      };

      let attackDirection = null;
      const teamA = this.$store.state.game.teamA;
      const teamB = this.$store.state.game.teamB;

      if (teamA && teamA.isAttacking) {
        attackDirection = teamA.component.direction;
      } else if (teamB && teamB.isAttacking) {
        attackDirection = teamB.component.direction;
      }

      if (optionalParams.otherTeamGoalKeeper) {
        optionalParams.otherTeamGoalKeeper = resolveGoalkeeper(optionalParams.otherTeamGoalKeeper);
      }

      // Ez a blokk csak akkor fut, ha NINCS kiválasztott játékos (automatikus kiegészítés)
      if(actions.includes(action) && (!params.selectedPlayer || !params.selectedTeamId || !params.selectedTeam)) {

        switch(attackDirection) {
          case 'left':
            params.selectedTeamId = 'teamA';
            params.selectedTeam = 1;
            optionalParams.selectedTeamId = 'teamA';
            optionalParams.selectedTeam = 1;
            let gkB = resolveGoalkeeper(this.gamedata ? this.gamedata.team_b_actual_goalkeeper : null);
            params.otherTeamGoalKeeper = gkB;
            optionalParams.otherTeamGoalKeeper = gkB;
            break;
          case 'right':
            params.selectedTeamId = 'teamB';
            params.selectedTeam = 2;
            optionalParams.selectedTeamId = 'teamB';
            optionalParams.selectedTeam = 2;
            let gkA = resolveGoalkeeper(this.gamedata ? this.gamedata.team_a_actual_goalkeeper : null);
            params.otherTeamGoalKeeper = gkA;
            optionalParams.otherTeamGoalKeeper = gkA;
            break;
        }
      }

      // Timeline másolat készítése a Store-ból
      let localTimeline = [];
      const sourceTimeline = this.timelineData || this.$store.state.game.timelineData || [];
      if (sourceTimeline) {
        localTimeline = JSON.parse(JSON.stringify(sourceTimeline));
      }

      localTimeline.sort(function(a, b) {
        if(a.period > b.period) return 1;
        else if(a.period === b.period) {
          if (a.params.gameTime > b.params.gameTime) return 1;
          if (a.params.gameTime === b.params.gameTime && a.clientTime > b.clientTime) return 1;
        }
        return -1;
      });

      // Gólszámítás
      let numOfScoreTeamA = 0;
      let numOfScoreTeamB = 0;

      localTimeline.forEach(function (obj) {
        // JAVÍTÁS: l. TimelineList.vue azonos javítása - a DMR törlése
        // boolean `true`-t ír a `deleted` mezőbe, a CR-é numerikus `1`-et.
        // Enélkül egy DMR által törölt gól TOVÁBBRA IS beleszámított minden
        // ezután rögzített új esemény "pillanatnyi eredmény" (teamScore)
        // mezőjébe - ez volt a "plusz gól jelent meg a jegyzőkönyvben" tünet
        // közvetlen oka.
        if(obj.deleted !== 1 && obj.deleted !== true &&
            obj.params.gameTime <= optionalParams.gameTime &&
            obj.params.selectedAction &&
            (CONSTANTS.ACTIONS.SINGLE_SCORE_ACTIONS.includes(obj.params.selectedAction.actionId) || CONSTANTS.ACTIONS.DOUBLE_SCORE_ACTIONS.includes(obj.params.selectedAction.actionId))
        ) {
          let increaseScoreBy = CONSTANTS.ACTIONS.DOUBLE_SCORE_ACTIONS.includes(obj.params.selectedAction.actionId) ? 2 : 1;
          if(obj.params.selectedTeamId === 'teamA') {
            numOfScoreTeamA += increaseScoreBy;
          }
          else if(obj.params.selectedTeamId === 'teamB') {
            numOfScoreTeamB += increaseScoreBy;
          }
        }
      });

      optionalParams.teamScore = {
        teamA: numOfScoreTeamA,
        teamB: numOfScoreTeamB
      };

      optionalParams.attackDirection = attackDirection ? attackDirection : null;

      if(action && (CONSTANTS.ACTIONS.SINGLE_SCORE_ACTIONS.includes(action) || CONSTANTS.ACTIONS.DOUBLE_SCORE_ACTIONS.includes(action)) && !this.blockByModification) {
        let increaseScoreBy = CONSTANTS.ACTIONS.DOUBLE_SCORE_ACTIONS.includes(action) ? 2 : 1;
        switch (optionalParams.selectedTeamId) {
          case 'teamA':
            optionalParams.teamScore = {
              teamA: numOfScoreTeamA += increaseScoreBy,
              teamB: numOfScoreTeamB
            };
            break;
          case 'teamB':
            optionalParams.teamScore = {
              teamA: numOfScoreTeamA,
              teamB: numOfScoreTeamB += increaseScoreBy
            };
            break;
        }
      }

      if(this.gamedata.dmr_enabled && [...CONSTANTS.DMR.DMR_DRAFTS, ...CONSTANTS.DMR.APPROVE_REQUIRED].includes(action)) {
        optionalParams.approved = false;
        optionalParams.rejectReason = null;
        optionalParams.message = '';
      }

      let calculatedTotalGameTime = self.recordCreateStartTotalGameTime;
      let calculatedGameTime = self.recordCreateStartTime;

      // JAVÍTÁS (79. tétel - 32021424205): ha a jegyzőkönyvvezető passzív
      // periódusban ("Mérkőzés vége", "Félidő") rögzít - pl. a lefújás után
      // elvégzett hetest -, az esemény az utolsó lejátszott félidőbe kerül (l.
      // game.js getRecordingPeriod). Korábban a "Mérkőzés vége" periódusba
      // került, és az ERP-nek beküldött félidő-eredmények nem adták ki a
      // végeredményt.
      let recordingCurrentPeriod = this.$store.state.game.currentPeriod;
      let recordingPeriod = this.$store.getters['game/getRecordingPeriod'](recordingCurrentPeriod);
      let recordingOptions = (recordingPeriod !== String(recordingCurrentPeriod)) ? {period: recordingPeriod} : undefined;

      if (this.createAction.gameTime) {
        let parts = this.createAction.gameTime.split(':');
        if (parts.length === 2) {
          let inputSeconds = parseInt(parts[0]) * 60 + parseInt(parts[1]);

          // --- MÓDOSÍTÁS KEZDETE ---
          // Ahelyett, hogy a stopper pillanatnyi (esetleg csúszó) értékéhez viszonyítanánk,
          // kiszámoljuk a pontos abszolút időt a félidő kezdete alapján.

          // A félidő, amelybe az esemény kerül (79. tétel: passzív periódusban
          // az utolsó lejátszott félidő, egyébként a jelenlegi)
          let currentPeriod = recordingPeriod;
          // Lekérjük a félidő kezdőidejét (pl. 0 vagy 1800) a Store getter segítségével
          let periodStartTime = this.$store.getters['game/getPeriodStartTime'](currentPeriod);

          // gametime = periódushoz relatív idő
          calculatedGameTime = inputSeconds - (periodStartTime || 0);

          // totalGameTime = abszolút kumulatív idő (Beírt Másodperc)
          calculatedTotalGameTime = inputSeconds;
          // --- MÓDOSÍTÁS VÉGE ---
        }
      } else if (recordingOptions) {
        calculatedGameTime = calculatedTotalGameTime - (this.$store.getters['game/getPeriodStartTime'](recordingPeriod) || 0);
      }

      self.recordCreateStartTotalGameTime = calculatedTotalGameTime;
      self.recordCreateStartTime = calculatedGameTime;

      // Autosave logika
      if(window.autosave && event === 'autosave' && !this.blockByModification) {
        if(self.saveTimeout) {
          window.clearTimeout(self.saveTimeout);
          window.clearTimeout(self.spinnerTimeout);
        }

        self.saveTime = window.saveTime;
        if(window.saveTime > 0) {
          self.spinner = 1;
          self.spinnerRoll();
        }

        self.saveTimeout = window.setTimeout(function() {
          if(!self.saveInProgress) return;
          optionalParams.isDraft = false;

          if (self.$store.getters['connection/isOffline']) {
            optionalParams.synced = false;
            optionalParams.syncDone = false;
          }

          let now = window.ts ? window.ts.now() : Date.now();
          window.dbmanager.write({
            action: action,
            params: optionalParams,
            totalGameTime: self.recordCreateStartTotalGameTime,
            gametime: self.recordCreateStartTime,
            date: now,
            clientTime: now
          }, undefined, recordingOptions).then((result) => {
            if(result) {
              window.dbmanager.read(result).then(function(record) {
                self.afterSave(record, true);
              });
            }
          });
        }, window.saveTime*1000);
      }
      else if(event === 'manualsave') {
        optionalParams.isDraft = !this.validateAction(action, optionalParams);

        // Ha nincs kapcsolat, jelöljük meg, hogy ez az adat még nincs a szerveren
        if (this.$store.getters['connection/isOffline']) {
          optionalParams.synced = false;
          optionalParams.syncDone = false;
        }

        if(this.blockByModification && this.modifiedRecordId) {
          let periodStartTime = this.$store.getters['game/getPeriodStartTime'](this.currentModifiedRecord.period);
          // Update logika
          let originalEvent = this.$store.state.game.timelineData.find(e => e.UUID === this.modifiedRecordId);
          let _record = originalEvent ? JSON.parse(JSON.stringify(originalEvent)) : {};
          let wasRejected = !!(_record.params && _record.params.rejectReason);

          let _params = Object.assign({}, self.createAction);
          _params = Object.assign(_params, optionalParams);

          _record.action = self.createAction.selectedAction ? self.createAction.selectedAction.actionId : null;
          if (!_record.params) _record.params = {};
          Object.assign(_record.params, _params);
          _record.params.isDraft = optionalParams.isDraft;
          _record.isDraft = optionalParams.isDraft;
          _record.UUID = this.modifiedRecordId;

          // JAVÍTÁS: Ha a rekord korábban DMR-elutasítást kapott, a javítás után
          // újra elfogadásra/elutasításra váró állapotba kell kerülnie - függetlenül
          // attól, hogy a dmr_enabled kapcsoló mit állított be feljebb.
          // JAVÍTÁS: eredetileg csak a beágyazott _record.params.* mezők lettek
          // visszaállítva - a FELSŐ SZINTŰ _record.approved/rejectReason/message
          // "tükör" mezők (amik a korábbi DMR-elutasítás DMRPUSH visszhangjából
          // kerültek CR helyi példányára, l. UPDATE_TIMELINE_EVENT mutáció) érintetlenül
          // maradtak, így a szerverre kimenő teljes (nem partialUpdate) mentés
          // továbbra is a régi elutasítás-státuszt hordozta a felső szintű mezőkön,
          // ami később (pl. DMR oldali mezőnkénti merge-nél) visszaszivároghatott.
          if (wasRejected) {
            _record.params.approved = false;
            _record.params.rejectReason = null;
            _record.params.message = null;
            _record.approved = false;
            _record.rejectReason = null;
            _record.message = null;
          }

          // JAVÍTÁS: az `originalEvent`-ből másolt `_record` örökölhet egy
          // `partialUpdate: true` jelzőt egy korábbi DMR jóváhagyás/elutasítás
          // visszhangjából (l. game.js UPDATE_TIMELINE_EVENT - a beérkező DMRPUSH
          // echo mezői rákerülnek a helyi másolatra). Ha ezt itt nem töröljük,
          // a most készülő rekord - ami valójában egy TELJES, tartalmi CR-javítás
          // (action/selectedPlayer/stb.) - a dbmanager.js sync()-jének
          // partialUpdate-ága által a szerverre kiküldéskor egy pár mezőre (csak
          // approved/rejectReason/stb.) lesz CSONKÍTVA - az action és a tartalmi
          // mezők soha nem jutnak el sem a szerverre, sem a DMR-hez. Egy CR-oldali
          // tartalmi mentés SOSEM lehet "partialUpdate".
          _record.partialUpdate = false;

          _record.period = this.currentModifiedRecord.period;
          // JAVÍTÁS: a _params.gameTime a mezőben látszó/szerkeszthető ABSZOLÚT
          // (meccs eleje óta eltelt) idő - ugyanúgy, mint új esemény felvételekor.
          // Az eredeti hiba az volt, hogy ebből a periódus-relatív gametime-ot a
          // JELENLEG AKTÍV félidő kezdetéhez képest számolta, nem a SZERKESZTETT
          // esemény saját félidejéhez képest - ezért a periodStartTime-ot kell
          // használni (ami this.currentModifiedRecord.period alapján lett kiszámolva),
          // nem a store aktuális currentPeriod-ját.
          let absSeconds = this.convertMMSS_to_Seconds(_params.gameTime);
          _record.gametime = absSeconds - (periodStartTime || 0);
          _record.totalGameTime = absSeconds;

          // Eredmény frissítésekor azonnal leütjük a Vuexbe is (mint a createnél), így nem "ugrál" a UI,
          // amíg a szerver válaszára várunk.
          self.$store.commit('game/UPDATE_TIMELINE_EVENT', _record);
          self.$store.dispatch('game/updateSortedTimeline');

          // --- JAVÍTÁS ITT: MINDIG FRISSÍTSÜK A clientTime-ot módosításkor! ---
          _record.clientTime = window.ts ? window.ts.now() : Date.now();
          // --- JAVÍTÁS VÉGE ---

          window.dbmanager.update(_record, false).then(function() {
            self.afterSave(_record, true);
          }).finally(() =>{
            self.buttonDisabledForSaving = false;
          });
        }
        else{
          // Create logika
          let now = window.ts ? window.ts.now() : Date.now();
          window.dbmanager.write({
            action: action,
            params: optionalParams,
            totalGameTime: self.recordCreateStartTotalGameTime,
            gametime: self.recordCreateStartTime,
            date: now,
            clientTime: now
          }, undefined, recordingOptions).then((result) => {
            if(result) {
              window.dbmanager.read(result).then(function(record) {
                self.afterSave(record, true);
              });
            }
          }).finally(() => {
            self.buttonDisabledForSaving = false;
          });
        }
      }
    },
    convertMMSS_to_Seconds(timeString) {
      if (!timeString || typeof timeString !== 'string' || !timeString.includes(':')) {
        console.warn("Érvénytelen idő string formátum: " + timeString + ". Elvárt formátum: 'MM:SS'");
        return 0;
      }

      const parts = timeString.split(':');

      if (parts.length !== 2) {
        console.warn("Érvénytelen idő string formátum: " + timeString + ". Elvárt formátum: 'MM:SS'");
        return 0;
      }

      const minutes = parseInt(parts[0], 10);
      const seconds = parseInt(parts[1], 10);

      // Ellenőrizzük, hogy a konverzió sikeres volt-e és számok-e az értékek
      if (isNaN(minutes) || isNaN(seconds)) {
        console.warn("Hibás számérték az idő stringben: " + timeString);
        return 0;
      }

      return (minutes * 60) + seconds;
},
manualSaveAction: function () {
      let action = (this.createAction.selectedAction && typeof this.createAction.selectedAction === 'object') ? this.createAction.selectedAction.actionId : this.createAction.selectedAction;

      // Ha nincs kiválasztva action, ne engedjük a mentést (még vázlatként sem)
      if (!action) {
        console.warn('[ActionBar] Mentés megtagadva: nincs kiválasztott action.');
        this.buttonDisabledForSaving = false;
        return;
      }

      this.buttonDisabledForSaving = true;
      let params = this.createAction;
      this.saveAction('manualsave', action, params);
      this.saveInProgress = false;
    },
    afterSave: function (record, resetUI) {
      let action = record.params.selectedAction ? record.params.selectedAction.actionId : null;

      // Új esemény objektum összeállítása
      let newItem = {
        id: record.UUID,
        UUID: record.UUID,
        action: action,
        params: record.params,
        isDraft: record.params.isDraft,
        clientTime: record.clientTime,
        period: record.period,
        gametime: record.gametime,
        totalGameTime: record.totalGameTime
      };

      // --- STORE FRISSÍTÉS (A régi gamedata manipuláció helyett) ---

      // 1. Timeline frissítése
      this.$store.commit('game/UPDATE_TIMELINE_EVENT', newItem);

      // 2. Lista rendezése (UI frissítése)
      // JAVÍTÁS (TELJESÍTMÉNY, 77. tétel): ha lent a RECALCULATE miatt úgyis
      // lefut a reCalculateScores (ugyanebben a szinkron körben, a kirajzolás
      // előtt), az a végén maga is rendezi a listát - a kettős rendezés egy
      // teljes meccs végére mentésenként ~30%-nyi felesleges munka volt.
      // A feltétel pontosan az App.vue RECALCULATE kezelőjéé.
      const willRecalculate = CONSTANTS.ACTIONS.RECALCULATE_ACTIONS.includes(action) ||
          (this.currentModifiedRecord && CONSTANTS.ACTIONS.RECALCULATE_ACTIONS.includes(this.currentModifiedRecord.action));
      if (!willRecalculate) {
        this.$store.dispatch('game/updateSortedTimeline');
      }

      // 3. UI állapotok resetelése
      this.saveInProgress = false;
      this.blockByModification = false;
      this.modifiedRecordId = null;

      this.$store.commit('game/SET_EDITING_RECORD', null);

      this.resetCourtDirection();

      let newRecord = {
        result: record.UUID,
        action: action,
        params: record.params,
        period: record.period,
        gameTime: record.gametime,
        totalGameTime: record.totalGameTime,
        modifiedRecord: this.currentModifiedRecord
      }

      if (resetUI) {
        eventBus.$emit(CONSTANTS.EVENTS.RECORD.CREATED, newRecord);
      } else {
        eventBus.$emit(CONSTANTS.EVENTS.RECORD.DMRSYNC, newRecord);
      }

      // 4. Eredmények újraszámolása (Ez frissíti a store-ban a team_a_score-t is)
      // A game.js-ben a reCalculateScores action kezeli ezt.
      eventBus.$emit(CONSTANTS.EVENTS.RECALCULATE, newRecord);

      if (['2perc', '4perc'].includes(action)) {
        this.$store.dispatch('game/givePenalty', {
          player: { id: record.params.selectedPlayer }, // Csak az ID kell a kereséshez
          event: newRecord // Átadjuk a mentett rekordot referenciának
        });
      }

      this.currentModifiedRecord = {};

      // --- MÓDOSÍTÁS KEZDETE: UI KÉNYSZERÍTETT TAKARÍTÁSA ---
      // Mivel a kapus gólja néha beragasztja a GoalKeeperDialog overlay-t,
      // itt biztosítjuk, hogy minden dialógus és töltőképernyő bezáródjon.

      // 1. Általános dialógusok bezárása EventBus-on keresztül
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false);

      // 2. GoalKeeperModal bezárása (EZ A LÉNYEG A MOSTANI HIBAHOZ)
      // A GoalKeeperModal a CONSTANTS.ACTIONS.CLOSE.MODAL eseményre figyel a szülőjében
      eventBus.$emit(CONSTANTS.ACTIONS.CLOSE.MODAL);

      // 3. Specifikus UI store állapotok resetelése
      // Ha a ui modul be van töltve, kényszerítjük a bezárást.
      if (this.$store.state.ui) {
        this.$store.commit('ui/SET_GOALKEEPER_DIALOG', false);
        this.$store.commit('ui/SET_STRAND_GOALKEEPER_DIALOG', false);
        this.$store.commit('ui/SET_OVERLAY', false); // Beragadt loading overlay ellen
      }
      // --- MÓDOSÍTÁS VÉGE ---
    },
    validateAction: function (action, params) {
      let neededParams = [];
      let actualParams = [];
      let tmpParams = Object.assign({}, params);
      let paramKeyChecker = (actual, needed) => needed.every(v => actual.includes(v));
      let extraValidator = () => true;

      if (!action || !params) {
        return false;
      }

      Object.keys(tmpParams).forEach(k => (!tmpParams[k]) && delete tmpParams[k]);

      switch (action) {
        case 'vazlat':
          // A 'vazlat' mindig invalid, hogy a rendszer isDraft=true jelzővel mentse el
          return false;
        case 'gol7m':
        case 'vedett7m':
        case 'gol6m':
        case 'vedett6m':
          neededParams = ['selectedPlayer', 'selectedTeam', 'selectedGateArea', 'gameTime', 'otherTeamGoalKeeper'];
          break;
        case 'rontott7m':
        case 'kapufa7m':
        case 'rontott6m':
        case 'kapufa6m':
          neededParams = ['selectedPlayer', 'selectedTeam', 'gameTime', 'otherTeamGoalKeeper'];
          break;
        case 'blokkolt':
          neededParams = ['selectedPlayer', 'selectedTeam', 'selectedArea', 'gameTime'];
          break;
        case 'gol':
        case 'gol2p':
        case 'vedett':
          neededParams = ['selectedPlayer', 'selectedTeam', 'selectedArea', 'selectedGateArea', 'gameTime', 'otherTeamGoalKeeper'];
          if (this.gamedata.rule === 'STRAND') neededParams.push('selectedActionType');
          break;
        case 'kapufa':
        case 'rontott':
          neededParams = ['selectedPlayer', 'selectedTeam', 'selectedArea', 'gameTime', 'otherTeamGoalKeeper'];
          if (this.gamedata.rule === 'STRAND') neededParams.push('selectedActionType');
          break;
        case 'eladott':
        case 'technikai':
          neededParams = ['selectedPlayer', 'selectedTeam'];
          break;
        case 'sargalap':
        case 'piroslap':
        case 'keklap':
          neededParams = ['selectedPlayer', 'selectedTeam', 'gameTime'];
          extraValidator = (params) => {
            let valid = true;
            // console.log("-> ExtraValidator futása..."); // Debug logok kivehetők

            if (this.gamedata.rule !== 'STRAND') {
              let pId = params.selectedPlayer;

              // Store-ból kérjük le a játékost
              let playerObj = this.$store.getters['game/getPlayerById'](pId);

              if (playerObj) {
                // Megnézzük, hogy épp ezt a konkrét játékost és eseményt szerkesztjük-e
                let isEditingThis = this.blockByModification &&
                    this.currentModifiedRecord &&
                    this.currentModifiedRecord.params.selectedPlayer == pId &&
                    this.currentModifiedRecord.action === action;

                // 1. CSAPAT LIMIT ELLENŐRZÉS
                if (action === 'sargalap') {
                  let teamKey = (playerObj.team === 'A' || playerObj.team === 'teamA') ? 'teamA' : 'teamB';
                  let type = playerObj.official ? 'officials' : 'players';

                  let stats = this.$store.state.game.yellows[type][teamKey];

                  // --- ÚJ RÉSZ: Intelligens limit számítás ---
                  let effectiveGiven = stats ? stats.given : 0;
                  let max = stats ? stats.max : 3;

                  // Ha szerkesztünk egy sárga lapot...
                  if (this.blockByModification &&
                      this.currentModifiedRecord &&
                      this.currentModifiedRecord.action === 'sargalap') {

                    // ...és a szerkesztett lap eredeti csapata megegyezik a most kiválasztott játékos csapatával...
                    let editedTeamId = this.currentModifiedRecord.params ? this.currentModifiedRecord.params.selectedTeamId : null;
                    // JAVÍTÁS: hivatalos személynél (staff) a selectedTeamId 'staffA'/'staffB',
                    // NEM 'teamA'/'teamB' (ami a teamKey mindig) - enélkül a normalizálás
                    // nélkül ez sosem talált egyezést hivatalos személy lapjánál, ezért ha a
                    // szerkesztett sárga lapot MÁSIK hivatalos személyre írták át (más
                    // selectedPlayer -> isEditingThis is false lett), a betelt (max=1) limit
                    // miatt a validáció elbukott, és a rekord "vázlat"-ként (isDraft=true)
                    // mentődött ahelyett, hogy véglegesként ment volna el.
                    let normalizedEditedTeamId = (editedTeamId === 'staffA') ? 'teamA' : (editedTeamId === 'staffB') ? 'teamB' : editedTeamId;
                    if (normalizedEditedTeamId === teamKey) {
                      // ...akkor a validáció idejére "kivonjuk" a statisztikából, mert épp mozgatjuk.
                      effectiveGiven = Math.max(0, effectiveGiven - 1);
                    }
                  }
                  // ------------------------------------------

                  // Most már az 'effectiveGiven'-t hasonlítjuk a max-hoz
                  // Az 'isEditingThis' ellenőrzés maradhat, de az effectiveGiven logika lefedi azt az esetet is.
                  if (!isEditingThis && effectiveGiven >= max) {
                    // console.warn("⛔ VALIDÁCIÓ HIBA: Betelt a csapat sárga lap limit!");
                    return false;
                  }
                }

                if (playerObj.cards) {
                  // 2. JÁTÉKOS EGYÉNI LAPOK ELLENŐRZÉSE

                  // SÁRGA LAP
                  if (action === 'sargalap' && !isEditingThis) {
                    if (playerObj.cards.yellow.value) {
                      return false; // Már van sárgája
                    }
                    if (playerObj.cards.red.value || playerObj.cards.blue.value) {
                      return false; // Már van piros/kék
                    }
                  }

                  // PIROS LAP
                  if (action === 'piroslap' && !isEditingThis) {
                    if (playerObj.cards.red.value || playerObj.cards.blue.value) {
                      return false;
                    }
                  }

                  // KÉK LAP
                  if (action === 'keklap' && !isEditingThis) {
                    if (!playerObj.cards.red.value || playerObj.cards.blue.value) {
                      return false;
                    }
                  }
                }
              } else {
                // console.error("CRITICAL: Játékos nem található");
                return false;
              }
            }
            return valid;
          };
          break;

        case 'kiallitas':
          neededParams = ['selectedPlayer', 'selectedTeam', 'gameTime'];
          extraValidator = (params) => {
            let player = window.players[params.selectedPlayer];
            let valid = player.validateKiallitasAction();
            return valid;
          };
          break;
        case '2perc':
        case '4perc':
          neededParams = ['selectedPlayer', 'selectedTeam', 'gameTime'];
          extraValidator = (params) => {
            // 1. Játékos lekérése a Store-ból (biztonságosabb, mint a window.players)
            let playerObj = this.$store.getters['game/getPlayerById'](params.selectedPlayer);

            if (!playerObj) return true; // Ha nincs meg, nem blokkoljuk

            // 2. Meglévő saját büntetések száma
            let ownPenalties = playerObj.penalties ? playerObj.penalties.filter(p => !p.scapegoat).length : 0;

            // 3. Szerkesztés ellenőrzése
            let isEditingThis = this.blockByModification &&
                this.currentModifiedRecord &&
                ['2perc', '4perc'].includes(this.currentModifiedRecord.action) &&
                this.currentModifiedRecord.params.selectedPlayer == params.selectedPlayer;

            // Ha szerkesztünk, akkor a jelenlegit kivonjuk a matekból
            if (isEditingThis) {
              ownPenalties = Math.max(0, ownPenalties - 1);
            }

            let maxPenalties = playerObj.maxPenalties || 3;

            // 4. Limit ellenőrzés
            if (action === '2perc') {
              if (ownPenalties + 1 > maxPenalties) return false;
            }
            if (action === '4perc') {
              // A 4 perces 2 "helyet" foglal el elvileg a szabályok szerint (vagy csak kizárja magát, ha nincs 2 hely?)
              // A game.js logika szerint +2-t nézünk.
              if (ownPenalties + 2 > maxPenalties) return false;
            }

            return true;
          };
          break;
      }

      if (this.basic) {
        let filterOut = [
          'selectedArea',
          'selectedGateArea',
          'otherTeamGoalKeeper'
        ];

        if (this.gamedata.rule !== 'STRAND') {
          filterOut.push('selectedActionType');
        }

        neededParams = neededParams.filter((item) => !filterOut.includes(item));
      }

      actualParams = Object.keys(tmpParams);
      return paramKeyChecker(actualParams, neededParams) && extraValidator(tmpParams);
    },
    deleteCreateActionValues: function () {
      this.createAction = {
        selectedPlayer: null,
        selectedScapegoat: null,
        selectedTeam: null,
        selectedAction: null,
        selectedActionType: null,
        selectedArea: null,
        selectedGateArea: null,
        gameTime: null,
        otherTeamGoalKeeper: null,
        selectedTeamId: null,
        teamScore: null
      };
    },
    /**
     * Az összes játékost újra enabledre rakja
     */
    enableEveryPlayer: function (key) {
      let players = [
        ...this.gamedata.team_a_players,
        ...this.gamedata.team_a_officials,
        ...this.gamedata.team_b_players,
        ...this.gamedata.team_b_officials,
      ];
      for (let player of players) {
        player.disabled[key] = false;
      }
    },
    /**
     * Letiltja az érdekelt játékosokat az eventtől függően
     *
     * @param string selectedAction
     */
    disablePlayersOnSelectedAction: function (selectedAction, action = 'action') {
      let callback;
      let time = 0; // A 2-4 perces kiállítások miatt itt definiálom
      let self = this;
      switch (selectedAction) {
        case 'sargalap':
          callback = (player) => {
            let type = player.official ? 'officials' : 'players';
            let team = player.team;

            // JAVÍTÁS: Közvetlenül a Store-ból olvassuk ki az adatokat, nem a root komponensből
            // Eredeti hibás sor: let yellows = self.$root.$children[0].yellows;
            let yellows = self.$store.state.game.yellows;

            let playerTeamKey = (team === 'A' || team === 'teamA') ? 'teamA' : 'teamB';

            // Jelenlegi állapot
            let givenCount = 0;
            let maxCount = 3;

            // Biztonsági ellenőrzés, hogy létezik-e az adatstruktúra a store-ban
            if (yellows && yellows[type] && yellows[type][playerTeamKey]) {
              givenCount = yellows[type][playerTeamKey].given;
              maxCount = yellows[type][playerTeamKey].max;
            }

            // Ha szerkesztünk, és ez a sárga lap ehhez a csapathoz tartozott,
            // akkor a limit számításnál átmenetileg levonjuk.
            if (self.blockByModification &&
                self.currentModifiedRecord &&
                self.currentModifiedRecord.action === 'sargalap') {
              let originalTeamId = self.currentModifiedRecord.params ? self.currentModifiedRecord.params.selectedTeamId : null;
              // JAVÍTÁS: hivatalos személynél (staff) a selectedTeamId 'staffA'/'staffB',
              // NEM 'teamA'/'teamB' (ami playerTeamKey mindig) - emiatt ez az
              // összehasonlítás sosem talált egyezést hivatalos személyek lapjánál,
              // így azok szerkesztése a betelt (max=1) limit miatt véglegesen tiltva
              // maradt. Normalizáljuk 'staffX'->'teamX'-re összehasonlítás előtt.
              let normalizedOriginalTeamId = (originalTeamId === 'staffA') ? 'teamA' : (originalTeamId === 'staffB') ? 'teamB' : originalTeamId;
              if (normalizedOriginalTeamId === playerTeamKey) {
                givenCount = Math.max(0, givenCount - 1);
              }
            }

            // Van-e már sárgája a játékosnak?
            let hasYellow = player.cards.yellow.value;

            // Szerkesztés kivétel (ha a saját lapját szerkesztjük)
            if (self.blockByModification &&
                self.currentModifiedRecord &&
                self.currentModifiedRecord.action === 'sargalap' &&
                self.currentModifiedRecord.params &&
                self.currentModifiedRecord.params.selectedPlayer === player.id) {
              hasYellow = false;
            }

            // TILTÁS, HA:
            // 1. Már van sárgája (és nem azt szerkesztjük)
            // 2. Vagy van piros/kék lapja
            // 3. Vagy ki van állítva
            // 4. Vagy a csapat elérte a limitet (max <= given)
            player.disabled.action |= hasYellow || player.cards.red.value || player.cards.blue.value
                || (player.penalties.length > 0)
                || maxCount <= givenCount;

            player.disabled.action = !!player.disabled.action;
          };
          break;
        case 'piroslap':
          // Piroslapot csak akkor kaphat, ha nincs piros lapja
          callback = (player) => {
            player.disabled.action |= player.cards.red.value;
            player.disabled.action = !!player.disabled.action;
          };
          break;
        case 'keklap':
          // JAVÍTÁS: Kéklapot csak akkor kaphat, ha nincs kék lapja, ÉS van már piros lapja
          callback = (player) => {
            // Disable ha: Van már kék VAGY Nincs piros
            player.disabled.action |= player.cards.blue.value || !player.cards.red.value;
            player.disabled.action = !!player.disabled.action;
          };
          break;
        case 'kiallitas':
          // Strand sárgából maximum kettő lehet
          callback = (player) => {
            player.disabled.action |= !(player.strandYellows.length < 2);
            // Akinek van piros lapja, annak annyi, mást nem csinálhat
            player.disabled.action |= player.cards.red.value;
            // Kék lap jelenleg nincs, de a jövőben előfordulhat
            player.disabled.action |= player.cards.blue.value;
            // Normális nyelvekben a `||` bool eredményt ad vissza, a JS természetesen nem :)
            player.disabled.action = !!player.disabled.action;
          };
          break;
        case '4perc':
          // 4 perces kiállítást, ...
          time++;
          // falls through <-- Ha kitörlöd ezt a kommentet, nem fordul :)
        case '2perc':
          // Illetve 2 perces kiállítást, csak akkor kaphat, ha a kiállításai száma nem haladja meg a 3-at
          // Avagy nincs piros vagy kék lapja
          time++;
          callback = (player) => {
            let now = window.stopwatch.getTotalTime();
            // MKSZOJK-58 kommentjei között van a hiba ami miatt ez az ellenőrzés itt van!
            if (player.penalties === undefined) {
              player.penalties = [];
            }
            player.disabled.action |= (player.penalties.filter((penalty) => {
                  // CSAK a saját kiállítások számítanak
                  return !penalty.scapegoat;
                }).length + time) > player.maxPenalties
                || (player.cards.red.value && player.cards.red.given <= now)
                || (player.cards.blue.value && player.cards.blue.given <= now)
                || (player.official && self.$root.$children[0].officialPenaltiesGiven[player.team.substr(-1)])
                || (player.official && time > 1)
            ;
            player.disabled.action = !!player.disabled.action;
          };
          break;
        default:
          // Minden egyéb esetben a kiállított és piros/kék lappal rendelkező játékosok disabledek
          // A 3 db kiállítást vagy 2 db kiállítást nem kell figyelni,
          // ilyenkor kap automagikusan egy piros lapot
          // Illetve a maradék eseményeket csak támadó játékos csinálhat
          callback = (player) => {
            let vedekezo = !(this.$root.$children[0][player.team].isAttacking);
            // MKSZOJK-58 kommentjei között van a hiba ami miatt ez az ellenőrzés itt van!
            if (player.penalties === undefined) {
              player.penalties = [];
            }
            player.disabled[action] |=
                // Aktív kiállítása van
                player.penalties.filter((penalty) => penalty.isActive).length
                // Piros vagy kék lapja van
                || player.cards.red.value
                || player.cards.blue.value
                || vedekezo
                || player.official
            ;
            player.disabled[action] = !!player.disabled[action];
          };
      }
      if (callback) {
        [
          ...self.gamedata.team_a_players,
          ...self.gamedata.team_a_officials,
          ...self.gamedata.team_b_players,
          ...self.gamedata.team_b_officials,
        ].forEach(callback);
      }
    },
    /**
     * Letiltja az érdekelt játékosokat a területtől függően
     *
     * @param string|undefined|null selectedArea
     */
    disablePlayersOnSelectedArea: function (selectedArea) {
      if (selectedArea) {
        this.disablePlayersOnSelectedAction('even dirtier hack', 'area');
      } else {
        this.enableEveryPlayer('area');
      }
    },
    disablePlayersOnBallPlacement: function (isPlaced) {
      if (isPlaced) {
        this.disablePlayersOnSelectedAction('even dirtier hack', 'gate');
      } else {
        this.enableEveryPlayer('gate');
      }
    },
  },
  created: function () {
    let self = this;

    if (self.gamedata && self.gamedata.rule === 'STRAND') {
      self.basic = true;
    } else {
      window.dbmanager.getConfig('basic').then((result) => {
        if (typeof result !== "undefined" && result !== null) {
          self.basic = result.value;
        }
      });
    }

    this.$busOn(CONSTANTS.ACTIONS.SELECTED.TEAM, function (selectedTeam) {
      self.selectedTeam = (selectedTeam === null || selectedTeam === undefined) ? null : selectedTeam;
      self.createAction.selectedTeam = (selectedTeam === null || selectedTeam === undefined) ? null : selectedTeam;
      self.createAction.selectedTeamId = selectedTeam;
    });
    this.$busOn(CONSTANTS.ACTIONS.SELECTED.PLAYER, function (selectedPlayer) {
      if (selectedPlayer !== null && selectedPlayer !== undefined) {
        let team = self.selectedTeam;
        let player = null;
        switch (team) {
          case 'teamA':
          case 'staffA':
            player = [
              ...self.gamedata.team_a_players,
              ...self.gamedata.team_a_officials,
            ].find(playerObj => playerObj.id === selectedPlayer);
            self.player = player;
            self.teamName = self.gamedata.team_a_shortname;
            self.createAction.selectedTeam = self.gamedata.team_a_id;
            self.createAction.otherTeamGoalKeeper = self.gamedata.team_b_actual_goalkeeper;
            break;
          case 'teamB':
          case 'staffB':
            player = [
              ...self.gamedata.team_b_players,
              ...self.gamedata.team_b_officials,
            ].find(playerObj => playerObj.id === selectedPlayer);
            self.player = player;
            self.teamName = self.gamedata.team_b_shortname;
            self.createAction.selectedTeam = self.gamedata.team_b_id;
            self.createAction.otherTeamGoalKeeper = self.gamedata.team_a_actual_goalkeeper;
            break;
        }
        self.createAction.selectedPlayer = self.player.id;
      } else {
        self.createAction.selectedPlayer = null;
        self.createAction.otherTeamGoalKeeper = null;
        self.player = {
          name: "",
          jersey: "",
        };
        self.teamName = null;
      }
    });
    this.$busOn(CONSTANTS.ACTIONS.SELECTED.ACTION, function (selectedAction) {
      if (selectedAction !== null && selectedAction !== undefined) {
        self.createAction.selectedAction = selectedAction;
        self.actualAction = selectedAction.actionName;
        self.disablePlayersOnSelectedAction(selectedAction.actionId);

        if (selectedAction.actionId === 'gol' ||
            selectedAction.actionId === 'vedett' ||
            selectedAction.actionId === 'gol7m' ||
            selectedAction.actionId === 'vedett7m' ||
            selectedAction.actionId === 'gol6m' ||
            selectedAction.actionId === 'vedett6m' ||
            selectedAction.actionId === 'gol2p') {
          if (self.createAction.selectedGateArea === undefined ||
              self.createAction.selectedGateArea === null ||
              self.createAction.selectedGateArea === 0) {
            eventBus.$emit(CONSTANTS.ACTIONS.OPENGATE, true);
          }
        } else {
          eventBus.$emit(CONSTANTS.ACTIONS.OPENGATE, false);
        }
      } else {
        self.createAction.selectedAction = null;
        self.actualAction = null;
        self.enableEveryPlayer('action');
        eventBus.$emit(CONSTANTS.ACTIONS.OPENGATE, false);
      }
    });
    this.$busOn(CONSTANTS.ACTIONS.SELECTED.ACTIONTYPE, function (selectedActionType) {
      self.createAction.selectedActionType = selectedActionType;
      self.actualActionTypeName = selectedActionType ? CONSTANTS.ACTIONS.ACTION_MAPPING[selectedActionType] : null;
    });
    this.$busOn(CONSTANTS.ACTIONS.SELECTED.GATE, function (selectedGateArea) {
      // Ha idáig eljutott, akkor elméletileg már hamarabb disabledre vannak rakva a játékosok
      self.createAction.selectedGateArea = (selectedGateArea === null || selectedGateArea === undefined) ? null : selectedGateArea;
    });
    this.$busOn(CONSTANTS.ACTIONS.SELECTED.AREA, function (selectedArea) {
      self.createAction.selectedArea = (selectedArea === null || selectedArea === undefined) ? null : selectedArea;
      // Lekezeli azt is, ha üres
      self.disablePlayersOnSelectedArea(self.createAction.selectedArea);
    });
    this.$busOn(CONSTANTS.ACTIONS.BALLPLACED, function (isPlaced) {
      self.disablePlayersOnBallPlacement(isPlaced);
    });
    this.$busOn(CONSTANTS.EVENTS.RECORD.CREATED, function () {
      self.deleteCreateActionValues();
      self.enableEveryPlayer('action');
      self.enableEveryPlayer('area');
      self.enableEveryPlayer('gate');
      self.enableEveryPlayer('player');
      self.enableEveryPlayer('actionType');
    });
    // Másik komponens hozott létre egy rekordot
    this.$busOn(CONSTANTS.EVENTS.RECORD.PUSH, function (record) {
      self.afterSave(record, false);
    });
    this.$busOn(CONSTANTS.EVENTS.BASICMODECHANGED, function (value) {
      self.basic = value;
      self.cancelAction();
    });
    this.$busOn(CONSTANTS.EVENTS.MODIFYITEMDATA, function (record) {
      if (record) {
        let selectedAction = record.params && record.params.selectedAction ? record.params.selectedAction : {};

        if (CONSTANTS.DMR.DMR_DRAFTS.includes(record.action)) {
          record.action = CONSTANTS.DMR.DRAFTS_TO_EVENT[record.action] ?? record.action;
          selectedAction.actionId = record.action;
        }

        self.blockByModification = true;
        self.modifiedRecordId = record.UUID ? record.UUID : record.id;
        self.$store.commit('game/SET_EDITING_RECORD', record);

        // --- IRÁNY BEÁLLÍTÁSA SZERKESZTÉSKOR (JAVÍTOTT) ---

        // 1. Elmentjük a jelenlegi irányt (hogy később vissza tudjuk állítani)
        let isTeamAAttacking = self.$store.state.game.teamA.isAttacking;
        self.preEditDirection = isTeamAAttacking ? 'left' : 'right';

        // 2. Megpróbáljuk kinyerni az irányt a rekordból
        let dir = record.params ? record.params.attackDirection : null;

        // 3. FALLBACK: Ha nincs elmentett irány, kitaláljuk a csapat alapján
        // (Ez javítja a hibát, amikor nem állt át a pálya)
        if (!dir && record.params && record.params.selectedTeamId) {
          if (record.params.selectedTeamId === 'teamA') dir = 'left';
          else if (record.params.selectedTeamId === 'teamB') dir = 'right';
        }

        // 4. Beállítjuk a pályát
        if (dir) {
          eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIRECTION, dir);
        }
        // ---------------------------------------------------

        self.createAction = {
          selectedPlayer: record.params ? record.params.selectedPlayer : null,
          selectedTeam: record.params ? record.params.selectedTeam : null,
          selectedAction: record.params ? selectedAction : null,
          selectedActionType: record.params ? record.params.selectedActionType : null,
          selectedArea: record.params ? record.params.selectedArea : null,
          selectedGateArea: record.params ? record.params.selectedGateArea : null,
          gameTime: record.params && record.params.gameTime ? record.params.gameTime : (record.gametime !== undefined ? self.formatSeconds(record.gametime) : null),
          otherTeamGoalKeeper: record.params ? record.params.otherTeamGoalKeeper : null,
          selectedTeamId: record.params ? record.params.selectedTeamId : null,        //teamA || teamB
          teamScore: record.params ? record.params.teamScore : null,
        };

        self.teamName = null;
        self.player = {
          name: "",
          jersey: "",
        };

        let player = null;
        if (record.params && record.params.selectedTeamId && record.params.selectedPlayer) {
          if (record.params.selectedTeamId === 'teamA' || record.params.selectedTeamId === 'staffA') {
            self.teamName = self.gamedata.team_a_shortname;
            player = self.gamedata.team_a_players.find(elem => elem.id === record.params.selectedPlayer);
            if (!player) player = self.gamedata.team_a_officials.find(elem => elem.id === record.params.selectedPlayer);
            self.player = {
              name: player ? player.name : null,
              jersey: player ? player.jersey : null,
            };
          } else if (record.params.selectedTeamId === 'teamB' || record.params.selectedTeamId === 'staffB') {
            self.teamName = self.gamedata.team_b_shortname;
            player = self.gamedata.team_b_players.find(elem => elem.id === record.params.selectedPlayer);
            if (!player) player = self.gamedata.team_b_officials.find(elem => elem.id === record.params.selectedPlayer);
            self.player = {
              name: player ? player.name : null,
              jersey: player ? player.jersey : null
            };
          }
        }

        if (record.params && selectedAction) {
          self.actualAction = selectedAction.actionName;
        }

        let _selectionParams = self.createAction;
        _selectionParams.attackDirection = record.params.attackDirection;
        self.currentModifiedRecord = record;
        eventBus.$emit(CONSTANTS.EVENTS.RECORD.CREATE, true);
        eventBus.$emit(CONSTANTS.ACTIONS.RESTORE.SELECTION, _selectionParams);
      }
    });
  },
  computed: {
    ...mapState('game', ['timelineData']),
    saveDisabled: function () {
      let disabled = false;

      // 0. Ha nincs kiválasztva action, a mentés gomb nem engedélyezett
      if (!this.createAction || !this.createAction.selectedAction) {
        return true;
      }

      // 1. Eredeti ellenőrzés (mezszám hiánya bizonyos eseményeknél)
      if (!this.player.jersey && this.createAction && this.createAction.selectedAction) {
        let action = this.createAction.selectedAction.actionId;
        if (action) {
          if (['kiallitas', 'keklap', 'piroslap', 'sargalap', '2perc', '4perc', 'timeOut'].includes(action)) {
            disabled = true;
          }
        }
      }

      // 2. Validáció alapú tiltás (EZ HIÁNYZOTT)
      // Ha a validateAction 'false'-t ad vissza (pl. betelt a sárga lap limit),
      // akkor tiltsuk le a gombot!
      /*if (!disabled && this.createAction && this.createAction.selectedAction) {
        let actionId = this.createAction.selectedAction.actionId;
        // Átadjuk az éppen szerkesztett paramétereket ellenőrzésre
        let isValid = this.validateAction(actionId, this.createAction);

        if (!isValid) {
          disabled = true;
        }
      }*/

      return disabled;
    }
  },
  watch: {
    gamedata: {
      handler(val) {
        if (val && val.rule === 'STRAND') {
          this.basic = true;
        }
      },
      deep: true
    },
    createAction: {
      handler: function (params) {
        //szedjük ki a gameTime-ot, ha egyedül csak az szerepel a createActionben
        let paramLength = Object.values(params).filter(val => val).length;
        if (paramLength === 1 && params.gameTime && !this.blockByModification) {
          this.createAction.gameTime = null;
          this.createAction.teamScore = null;
        }
        paramLength = Object.values(params).filter(val => val).length;

        if (paramLength) {
          eventBus.$emit(CONSTANTS.EVENTS.RECORD.CREATE, true);
          if (!this.createAction.gameTime) {
            let modifiedRecordGameTime = (this.currentModifiedRecord && this.currentModifiedRecord.params) ? this.currentModifiedRecord.params.gameTime : null;
            this.createAction.gameTime = this.blockByModification ? modifiedRecordGameTime : window.stopwatch.getTotalTimeAsString();
            this.recordCreateStartTime = window.stopwatch.getTime();
            this.recordCreateStartTotalGameTime = window.stopwatch.getTotalTime();
          }

          if (this.createAction.selectedAction && this.createAction.selectedAction.actionId) {
            let valid = this.validateAction(this.createAction.selectedAction.actionId, params);
            if (valid) {
              this.saveInProgress = true;
              this.saveAction('autosave', this.createAction.selectedAction.actionId, this.createAction);
            }
          }
        } else {
          eventBus.$emit(CONSTANTS.EVENTS.RECORD.CREATE, false);
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.container-outer {
  width: 100%;
  height: 100%;
  padding-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 0;
}

.action-outer {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 100%;
  border-left-width: 2px;
  border-right-width: 2px;
  border-top-width: 2px;
  border-left-style: solid;
  border-right-style: solid;
  border-top-style: solid;
}

.action-title {
  font-size: 12px;
  font-stretch: condensed;
  font-family: 'Roboto Condensed';
  font-style: italic;
  margin-top: 10px;
}

.action-progress {
  margin-top: 10px;
}

.arrow-inner {
  text-align: center;
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: bold;
  font-stretch: condensed;
  font-family: 'Roboto Condensed';
}

.action-name:not(.reverseArrow) {
  margin-left: 18px;
}

.action-name.reverseArrow {
  margin-left: 10px;
}

.action-name .arrow-inner {
  width: 170px;
  padding-right: 20px;
}

.action-name, .player-text {
  position: relative;
  padding-left: 8px;
  padding-right: 8px;
  height: 36px;
  line-height: 36px;
}

.theme--light.action-name.reverseArrow:before, .theme--light.player-text.reverseArrow:after {
  border-color: transparent transparent transparent #9298af;
}

.theme--dark.action-name.reverseArrow:before, .theme--dark.player-text.reverseArrow:after {
  border-color: transparent transparent transparent #ffffff;
}

.theme--light.action-name:not(.reverseArrow):before, .theme--light.player-text:not(.reverseArrow):after {
  border-color: transparent #9298af transparent transparent;
}

.theme--dark.action-name:not(.reverseArrow):before, .theme--dark.player-text:not(.reverseArrow):after {
  border-color: transparent #ffffff transparent transparent;
}

.action-name:not(.reverseArrow):before, .player-text:not(.reverseArrow):after {
  border-width: 18px 10px 18px 0;
  left: -10px;
}

.action-name.reverseArrow:before, .player-text.reverseArrow:after {
  border-width: 18px 0 18px 10px;
  right: -10px;
}

.action-name:before, .player-text:after {
  content: '';
  position: absolute;
  top: 0;
  width: 0;
  height: 0;
  border-style: solid;
  clear: both;
}

.theme--light.player-text:not(.reverseArrow):before {
  border-color: transparent #ffffff transparent transparent;
}

.theme--dark.player-text:not(.reverseArrow):before {
  border-color: transparent #262830 transparent transparent;
}

.theme--light.player-text.reverseArrow:before {
  border-color: transparent transparent transparent #ffffff;
}

.theme--dark.player-text.reverseArrow:before {
  border-color: transparent transparent transparent #262830;
}

.theme--light.player-text:after {
  background-color: #ffffff;
}

.theme--dark.player-text:after {
  background-color: #262830;
}

.player-text:before {
  content: '';
  position: absolute;
  top: 0;
  width: 0;
  height: 0;
  border-style: solid;

  clear: both;
}

.player-text:not(.reverseArrow):before {
  left: -20px;
  border-width: 18px 10px 18px 0;
}

.player-text.reverseArrow:before {
  right: -20px;
  border-width: 18px 0 18px 10px;
}

.v-btn.action-time {
  margin-left: 8px;
  height: 36px !important;
  border-width: 1px;
}

.team-name {
  font-size: 12px;
  font-weight: bold;
  font-stretch: condensed;
  font-family: 'Roboto Condensed';
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-left: 8px;
}

.v-btn {
  height: 40px !important;
}

.bottom-actions {
  border-left-width: 1px;
  border-left-style: solid;
  border-right-width: 1px;
  border-right-style: solid;
}

.bottom-actions:first-child {
  border-left-width: 0;
}

.bottom-actions:last-child {
  border-right-width: 0;
}
</style>

<style>
.v-progress-circular__underlay {
  stroke: transparent !important;
}

.v-progress-circular__overlay {
  transition: unset !important;
}
</style>
